/**
 * Handles unit toggling for the default wig cap size guide table.
 */
class SizeGuideComponent extends HTMLElement {
  connectedCallback() {
    this.#unitFieldset = this.querySelector('.size-guide__unit-toggle');
    if (!this.#unitFieldset) return;

    this.#unitFieldset.addEventListener('change', this.#handleUnitChange);
  }

  disconnectedCallback() {
    this.#unitFieldset?.removeEventListener('change', this.#handleUnitChange);
  }

  /** @type {HTMLFieldSetElement | null} */
  #unitFieldset = null;

  /** @param {Event} event */
  #handleUnitChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

    this.#updateUnits(target.value);
  };

  /**
   * @param {string} unit
   */
  #updateUnits(unit) {
    const useCentimeters = unit === 'centimeters';

    this.querySelectorAll('[data-inch][data-cm]').forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      element.textContent = useCentimeters ? element.dataset.cm : element.dataset.inch;
    });
  }
}

if (!customElements.get('size-guide-component')) {
  customElements.define('size-guide-component', SizeGuideComponent);
}
